var map = {
	"./accordanse.png": 7045,
	"./artisans.png": 7569,
	"./bugul-noz.png": 8801,
	"./malmedienne.webp": 2418,
	"./marteaux.jpeg": 7558,
	"./orphee.jpeg": 5146
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4630;